// Curated stylized world dot grid - simple equirectangular mapping for radar.
// Each entry [lng, lat] roughly traces continental outlines. Hand-curated for
// a distinctive, designed look (not a photoreal map).
export const WORLD_DOTS = [
  // North America
  [-160,68],[-150,68],[-140,68],[-130,68],[-130,60],[-120,60],[-110,60],[-100,60],[-90,60],[-80,60],[-70,60],
  [-130,52],[-120,52],[-110,52],[-100,52],[-90,52],[-80,52],[-70,52],[-60,52],
  [-125,44],[-115,44],[-105,44],[-95,44],[-85,44],[-75,44],[-65,44],
  [-120,36],[-110,36],[-100,36],[-90,36],[-80,36],[-70,36],
  [-115,28],[-105,28],[-95,28],[-85,28],[-78,24],
  // Central / South America
  [-95,20],[-85,15],[-78,8],[-72,4],[-65,0],[-58,-4],[-52,-8],[-58,-14],[-65,-20],[-70,-28],[-65,-36],[-70,-44],[-72,-50],
  [-60,-30],[-55,-22],[-50,-15],[-45,-8],[-40,-5],[-48,-2],
  // Europe
  [-8,38],[0,40],[8,42],[15,44],[22,46],[28,48],[35,50],
  [-5,48],[2,50],[8,52],[15,53],[22,55],[28,57],
  [0,58],[8,60],[15,62],[22,64],[28,66],[18,68],
  // Africa
  [-12,28],[0,28],[10,28],[20,28],[30,28],
  [-10,16],[0,16],[10,16],[20,16],[30,16],[38,12],
  [-5,4],[8,4],[18,4],[28,4],[38,4],
  [10,-6],[20,-6],[30,-6],[38,-4],
  [15,-18],[24,-18],[32,-18],
  [20,-28],[28,-28],
  [25,-34],
  // Middle East / Central Asia
  [42,30],[48,32],[52,30],[58,30],[64,32],[70,32],
  [45,38],[52,40],[60,40],[68,42],[75,44],[80,46],[88,48],
  // South Asia
  [70,28],[78,24],[80,18],[85,22],[88,26],[92,24],[78,12],[82,8],
  // East / SE Asia
  [95,30],[100,32],[105,34],[112,36],[120,38],[128,40],[135,42],
  [100,22],[108,22],[116,24],[122,24],[130,28],[138,32],[140,38],
  [100,12],[110,8],[118,8],[125,6],[100,2],[112,-2],[120,-4],
  [135,-2],[140,-6],[120,-8],[128,-8],[140,-10],
  // Australia / NZ
  [115,-22],[125,-22],[135,-22],[145,-22],[152,-28],
  [118,-32],[130,-32],[142,-34],[148,-38],
  [172,-42],[176,-44],
  // Misc islands / fill
  [-15,30],[-22,16],[-18,4],[55,-20],[60,-12],
];

// Project equirectangular (lng,lat) → 2D pixel coords in a [0..1] box.
export function projectLngLat(lng, lat) {
  const x = (lng + 180) / 360;
  const y = (90 - lat) / 180;
  return { x, y };
}
